import { CartAddEvent } from '@theme/events';

class PTWCartRecommendations extends HTMLElement {
  #busy = false;

  connectedCallback() {
    this.addEventListener('submit', this.#addItem);
    this.addEventListener('change', this.#updatePrice);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.#addItem);
    this.removeEventListener('change', this.#updatePrice);
  }

  #updatePrice = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-ptw-variant]')) return;
    const price = select.closest('.ptw-cart-suggestion')?.querySelector('[data-ptw-price]');
    if (price && select.selectedOptions[0]?.dataset.price) price.textContent = select.selectedOptions[0].dataset.price;
  };

  #addItem = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-ptw-add-form]')) return;
    event.preventDefault();
    event.stopPropagation();
    if (this.#busy || !form.reportValidity()) return;

    const select = form.querySelector('[data-ptw-variant]');
    if (!(select instanceof HTMLSelectElement) || !select.value) return;
    const button = form.querySelector('button[type="submit"]');
    const label = button.textContent;
    const error = this.querySelector('.ptw-cart-recommendations__error');
    const controls = this.querySelectorAll('button, select');
    this.#busy = true;
    this.setAttribute('aria-busy', 'true');
    controls.forEach(control => { control.disabled = true; });
    button.textContent = this.dataset.adding;
    if (error) error.hidden = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(select.value), quantity: 1 }],
          sections: [this.dataset.sectionId],
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
      const html = new DOMParser().parseFromString(data.sections?.[this.dataset.sectionId] || '', 'text/html');
      let itemCount = Number(html.querySelector('[ref="cartItemCount"]')?.textContent);
      if (!Number.isFinite(itemCount) || itemCount < 1) {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!cartResponse.ok) throw new Error(this.dataset.error);
        itemCount = (await cartResponse.json()).item_count;
      }
      this.dispatchEvent(new CartAddEvent(data, 'ptw-cart-recommendations', {
        source: 'ptw-cart-recommendations',
        itemCount,
        sections: data.sections,
      }));
    } catch (failure) {
      if (error) {
        error.textContent = failure instanceof Error ? failure.message : this.dataset.error;
        error.hidden = false;
      }
    } finally {
      this.#busy = false;
      this.removeAttribute('aria-busy');
      controls.forEach(control => { control.disabled = false; });
      button.textContent = label;
    }
  };
}

if (!customElements.get('ptw-cart-recommendations')) {
  customElements.define('ptw-cart-recommendations', PTWCartRecommendations);
}
